
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaisedancabs() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Sedan Cab',
        heading: 'Skyline Cabs: Pune to Mumbai Sedan Cab',
        headingDescription: 'Skyline Cabs offers comfortable and affordable Pune to Mumbai Sedan Cab services. Perfect for solo travelers, couples, or small families, our sedan cabs provide a smooth and stylish ride with great fuel efficiency and comfort. Whether it’s a business trip, personal visit, or airport transfer, our professional drivers and well-maintained vehicles ensure a safe and timely journey. Book your Pune to Mumbai sedan cab with Skyline Cabs today for a relaxed and budget-friendly travel experience.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Sedan Cab",
      "description": "Skyline Cabs offers affordable and comfortable sedan cabs for your Pune to Mumbai journey. Enjoy a smooth ride in well-maintained vehicles like the Swift Dzire and Toyota Etios, perfect for solo travelers or small groups."
    },
    {
      "name": "Pune to Mumbai Swift Dzire Cab",
      "description": "Book a Swift Dzire for a budget-friendly yet comfortable ride from Pune to Mumbai. Ideal for small families or business travelers, the Swift Dzire offers great mileage and a smooth ride."
    },
    {
      "name": "Pune to Mumbai Etios Cab Booking",
      "description": "Skyline Cabs offers Toyota Etios cabs for your Pune to Mumbai trip. Known for its comfort and fuel efficiency, the Etios is perfect for a reliable, cost-effective ride between Pune and Mumbai."
    },
    {
      "name": "Pune to Mumbai Xcent Cab Booking",
      "description": "The Hyundai Xcent is an excellent choice for a comfortable ride from Pune to Mumbai. Book a cab with Skyline Cabs for a smooth and relaxing journey, equipped with AC and spacious interiors."
    },
    {
      "name": "Pune to Mumbai Airport Sedan Cab",
      "description": "Skyline Cabs provides sedan services for Pune to Mumbai Airport transfers. Our vehicles like Swift Dzire and Etios ensure timely and comfortable airport drop-offs with experienced drivers."
    },
    {
      "name": "Pune to Dadar Sedan Cab",
      "description": "Skyline Cabs offers reliable and affordable sedan cabs from Pune to Dadar. Choose from popular models like Swift Dzire or Etios for a convenient and comfortable trip."
    },
    {
      "name": "Pune to Andheri Sedan Cab",
      "description": "Travel from Pune to Andheri in comfort with our sedan cabs. With options like Swift Dzire and Etios, you can expect a smooth ride with professional drivers ensuring your safety and comfort."
    },
    {
      "name": "Pune to Mumbai One Way Sedan Cab",
      "description": "Skyline Cabs provides one-way sedan services for your Pune to Mumbai trip. Perfect for quick business trips or one-way travel, our sedans like Swift Dzire and Etios offer great comfort at competitive rates."
    },
    {
      "name": "Pune to Mumbai Airport Sedan Cab",
      "description": "Book a sedan for your airport transfer from Pune to Mumbai with Skyline Cabs. Our reliable services include smooth, timely pickups, whether you're traveling for business or leisure."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Opt for a round-trip sedan cab service from Pune to Mumbai with Skyline Cabs. Our round-trip packages offer flexibility, ensuring you have a comfortable and efficient journey both ways."
    },
    {
      "name": "Pune to Mumbai Swift Dzire Cab",
      "description": "The Swift Dzire is one of the most popular choices for a comfortable ride from Pune to Mumbai. Skyline Cabs offers this sedan with excellent mileage and reliability for your travel needs."
    },
    {
      "name": "Pune to Mumbai Swift Dzire Cab Booking Online",
      "description": "Book a Swift Dzire sedan cab from Pune to Mumbai online with Skyline Cabs. Our easy booking process and competitive pricing ensure a hassle-free experience for your journey."
    },
    {
      "name": "Pune to Mumbai Etios Cab",
      "description": "Choose the Toyota Etios for a comfortable and economical ride from Pune to Mumbai. Skyline Cabs provides well-maintained Etios cars that ensure a smooth and stress-free journey."
    },
    {
      "name": "Pune to Mumbai 5 Seater Cab",
      "description": "Skyline Cabs offers 5-seater sedans for your Pune to Mumbai travel. Ideal for small groups or families, our cabs like the Swift Dzire or Etios ensure comfort and a pleasant journey."
    },
    {
      "name": "Pune to Mumbai 4 Seater Cab",
      "description": "For those traveling alone or in pairs, Skyline Cabs offers 4-seater sedan options from Pune to Mumbai. Our compact yet comfortable cars like Swift Dzire are perfect for your journey."
    },
    {
      "name": "Pune to Andheri Sedan Cab",
      "description": "Skyline Cabs provides efficient sedan services from Pune to Andheri. Book your Swift Dzire or Etios for a smooth, hassle-free trip, with professional drivers ensuring a timely arrival."
    },
    {
      "name": "Pune to Mumbai Central Sedan Cab Service",
      "description": "For travel between Pune and Mumbai Central, Skyline Cabs offers sedan cabs like Swift Dzire and Etios. Our cabs are ideal for city transfers, providing comfort and reliability at affordable rates."
    },
    {
      "name": "Pune to Dadar Sedan Cab",
      "description": "Travel from Pune to Dadar with Skyline Cabs' sedan services. Our Swift Dzire and Etios sedans offer a comfortable, cost-effective option for your journey, ensuring a smooth ride."
    },
    {
      "name": "Skyline Cabs Pune",
      "description": "Skyline Cabs is a trusted provider of reliable and affordable taxi services in Pune. We offer sedan cabs for both local and outstation travel, including trips to Mumbai, with convenient online booking and professional drivers."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs provides reliable and prompt taxi services in Pune, offering a range of vehicles including sedan cabs like Swift Dzire and Etios. Whether you need a local ride or an outstation trip, we've got you covered."
    },
    {
      "name": "Pune to Mumbai Cab",
      "description": "Skyline Cabs provides comfortable and affordable cab services for your Pune to Mumbai journey. Choose from a fleet of sedans like Swift Dzire, Toyota Etios, or Xcent, all driven by professional chauffeurs."
    },
    {
      "name": "Sedan Cab Service in Pimpri Chinchwad",
      "description": "Skyline Cabs offers dependable sedan cab services from Pimpri Chinchwad to various destinations, including Mumbai. Our fleet includes Swift Dzire, Etios, and other vehicles to suit your travel needs."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Sedan Cab", "Pune to Mumbai Swift Dzire Cab"],
    ["Pune to Mumbai Etios Cab Booking", "Pune to Mumbai Xcent Cab Booking"],
    ["Pune to Mumbai Airport Sedan Cab", "Pune to Dadar Sedan Cab"],
    ["Pune to Andheri Sedan Cab", "Pune to Mumbai One Way Sedan Cab"],
    ["Pune to Mumbai Airport Sedan Cab", "Pune to Mumbai Cab Round Trip"],
    ["Pune to Mumbai Swift Dzire Cab", "Pune to Mumbai Swift Dzire Cab Booking Online"],
    ["Pune to Mumbai Etios Cab", "Pune to Mumbai 5 Seater Cab"],
    ["Pune to Mumbai 4 Seater Cab", "Pune to Andheri Sedan Cab"],
    ["Pune to Mumbai Central Sedan Cab Service", "Pune to Dadar Sedan Cab"],
    ["Skyline Cabs Pune", "Cab Service in Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Sedan Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable sedan services for your Pune to Mumbai journey, ensuring you arrive at your destination on time and stress-free. Whether it’s for business, leisure, or an airport transfer, our sedans provide the perfect blend of comfort and punctuality."
    },
    {
        "WhyChooseheading": "Comfortable and Efficient Travel",
        "WhyChoosedescription": "Our well-maintained sedans are perfect for a smooth and comfortable ride between Pune and Mumbai. With ample legroom, air-conditioning, and a comfortable seating arrangement, you'll enjoy a pleasant journey throughout your trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Smooth Journeys",
        "WhyChoosedescription": "Skyline Cabs’ professional drivers are familiar with the Pune to Mumbai route and will ensure your trip is smooth and hassle-free. They are well-trained, courteous, and committed to delivering a safe and efficient travel experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive and transparent pricing for your Pune to Mumbai sedan ride. We believe in no hidden charges—what you see is what you pay, making it easy to budget for your trip with confidence."
    },
    {
        "WhyChooseheading": "24/7 Availability for Anytime Travel",
        "WhyChoosedescription": "Skyline Cabs is available around the clock to ensure you can travel from Pune to Mumbai at any time of day or night. Whether you need an early morning ride or a late-night cab, we’ve got you covered with a seamless booking experience."
    },
    {
        "WhyChooseheading": "Perfect for Solo and Small Group Travel",
        "WhyChoosedescription": "Our sedans are ideal for solo travelers or small groups. With comfortable seating and a smooth ride, you can enjoy a peaceful journey to Mumbai, whether you’re traveling for business or leisure."
    },
    {
        "WhyChooseheading": "Quick and Easy Online Booking",
        "WhyChoosedescription": "Booking a sedan cab from Pune to Mumbai is fast and easy with our intuitive online platform. Use our website or mobile app to book your ride, get instant confirmation, and track your cab in real-time for a hassle-free experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Ride with GPS Tracking",
        "WhyChoosedescription": "We prioritize your safety during every journey. All our sedans are equipped with GPS for real-time tracking, and our drivers undergo thorough background checks. Travel with peace of mind knowing your safety is our top priority."
    }
]















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a Sedan from Pune to Mumbai with Skyline Cabs?',
            answer:
                'Booking is easy! Simply visit our website or use our mobile app to select Pune as your pickup location, Mumbai as your destination, and choose “Sedan” as your vehicle option. You can also contact our support team for assistance.',
        },
        {
            id: 2,
            question: 'Why should I choose a Sedan for my Pune to Mumbai trip?',
            answer:
                'A Sedan offers comfort, fuel efficiency, and a smooth ride, especially for solo travelers or couples. It’s perfect for shorter journeys where you don’t need as much space as an SUV or MPV, but still want a comfortable and stylish ride.',
        },
        {
            id: 3,
            question: 'Is the fare for a Sedan cab from Pune to Mumbai fixed?',
            answer:
                'Yes, our Sedan fares are fixed and transparent. The fare includes tolls, taxes, driver allowance, and other charges, so you know exactly what you’ll pay without any surprises.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round trip in a Sedan?',
            answer:
                'Yes, we offer both one-way and round-trip options. Whether you’re traveling for business or leisure, you can select the best option during your booking process.',
        },
        {
            id: 5,
            question: 'Is the Sedan comfortable for a 3-4 hour ride?',
            answer:
                'Absolutely! Our Sedans are known for their smooth suspension, spacious interiors, and comfortable seating. They are perfect for a 3-4 hour drive from Pune to Mumbai, ensuring a relaxing journey.',
        },
        {
            id: 6,
            question: 'Are the Sedans air-conditioned?',
            answer:
                'Yes, all of our Sedans are fully air-conditioned, ensuring a comfortable journey, especially during warm weather or long-distance travel.',
        },
        {
            id: 7,
            question: 'Can I pre-book a Sedan for my Pune to Mumbai trip?',
            answer:
                'Yes, we encourage advance booking, especially during busy hours or weekends. You can easily book your ride via our app or website, or by calling our customer support.',
        },
        {
            id: 8,
            question: 'Are the Sedan drivers experienced?',
            answer:
                'Yes, all of our drivers are well-trained, background-verified, and experienced in long-distance driving, ensuring that you get a smooth and safe ride.',
        },
        {
            id: 9,
            question: 'Can I book a Sedan for airport transfers from Pune to Mumbai?',
            answer:
                'Yes, you can book a Sedan for airport drop-offs and pickups. Just share your flight details, and we will ensure a timely and hassle-free transfer to or from Mumbai Airport.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for a Sedan ride?',
            answer:
                'Skyline Cabs offers competitive pricing, well-maintained vehicles, professional drivers, and a seamless booking experience. Whether it’s a business trip or a family getaway, our Sedans provide a comfortable, reliable ride.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Tanmay Shah",
            rating: 5,
            review: "Booked a Sedan from Pune to Mumbai for a business trip, and I couldn’t be happier with the service. The car was clean, the driver was courteous, and the ride was smooth and quick. Excellent value for money."
        },
        {
            name: "Miss. Priya Joshi",
            rating: 4,
            review: "The Sedan ride from Pune to Mumbai was very comfortable. The driver was punctual, and the car had all the amenities. Would’ve appreciated a bottle of water, but overall, it was a pleasant experience."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mumbai Sedan Cab by Skyline Cabs",
        "description": "Travel comfortably with Skyline Cabs' Pune to Mumbai Sedan service. Choose from Swift Dzire, Etios, or Xcent for airport transfers, one-way trips, and round trips. Call 7620911746 to book now.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "4500"
        }
      };
      
     
      



    return (
        <div>

<Helmet>
        <title>Pune to Mumbai Sedan Cab | Skyline Cabs</title>
        <meta
          name="description"
          content="Skyline Cabs offers reliable and affordable Pune to Mumbai Sedan cab services, including Swift Dzire, Etios, and Xcent. Enjoy a comfortable ride for one-way trips, airport transfers, and round trips. Call 7620911746 to book your ride."
        />
        <meta
          name="keywords"
          content="Pune to Mumbai Sedan Cab, Pune to Mumbai Swift Dzire Cab, Pune to Mumbai Etios Cab Booking, Pune to Mumbai Xcent Cab Booking, Pune to Mumbai Airport Sedan Cab, Pune to Dadar Sedan Cab, Pune to Andheri Sedan Cab, Pune to Mumbai One Way Sedan Cab, Pune to Mumbai Airport Sedan Cab, Pune to Mumbai Cab Round Trip, Pune to Mumbai Swift Dzire Cab, Pune to Mumbai Swift Dzire Cab Booking Online, Pune to Mumbai Etios Cab, Pune to Mumbai 5 Seater Cab, Pune to Mumbai 4 Seater Cab, Pune to Andheri Sedan Cab, Pune to Mumbai Central Sedan Cab Service, Pune to Dadar Sedan Cab, Skyline Cabs Pune, Cab Service in Pune, Pune to Mumbai Airport Cab, Pune Mumbai Cab, Sedan Cab Service in Pune, Sedan Cab Service in Pimpri Chinchwad"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/68.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaisedancabs;